export const uz = {
    "n1": "Bosh sahifa",
    "n2": "Buyurtmalar",
    "n3": "Savdo",
    "n4": "Jamoa",
    "n5": "Mening",
    "t1": "Xatolik yuz berdi",
    "t2": "Muvaffaqiyatli nusxa olindi",
    "t3": "Iltimos, barcha ma’lumotlarni to‘ldiring",
    "t4": "Yuklanmoqda…",
    "t5": "Kirish muvaffaqiyatli",
    "t6": "Baholash 3 dan katta bo‘lishi kerak",
    "t7": "Yuborish muvaffaqiyatli",
    "t8": "Balans yetarli emas",
    "t9": "Yuborish muvaffaqiyatsiz",
    "t10": "Avval manzilni bog‘lang, shaxsiy sahifaga yo‘naltirilasiz",
    "t11": "Manzil allaqachon bog‘langan, o‘zgartirish uchun qo‘llab-quvvatlashga murojaat qiling",
    "t12": "O‘zgartirish muvaffaqiyatli",
    "t13": "O‘zgartirish muvaffaqiyatsiz",
    "t14": "Parolni o‘zgartirish uchun qo‘llab-quvvatlashga murojaat qiling",
    "t15": "Parol formati noto‘g‘ri",
    "t16": "Pul yechish muvaffaqiyatli",
    "t17": "Maksimal yechish",
    "t18": "Minimal yechish",
    "t19": "Parollar mos emas",
    "t20": "Ogohlantirish",
    "t21": "Hozircha o‘tish mumkin emas",
    "t22": "Parol formati noto‘g‘ri",
    "t23": "Ro‘yxatdan o‘tish muvaffaqiyatli",
    "t24": "Iltimos, mamlakat kodini kiriting",
    "t25": "Boshqa ma’lumot yo‘q",
  
    "l1": "Til",
    "l2": "Hisobni kiriting",
    "l3": "Parolni kiriting",
    "l4": "Eslab qolish",
    "l5": "Kirish",
    "l6": "Ro‘yxatdan o‘tish",
    "l7": "Hisobingiz yo‘qmi",
    "l8": "Telefon raqam",
    "l9": "Taxallus",
    "l10": "Parol",
    "l11": "Parolni tasdiqlang",
    "l12": "Taklif kodi",
    "l13": "Ro‘yxatdan o‘tish",
    "l14": "Hisobingiz bormi",
    "l15": "Kirish",
    "l16": "6-16 xonali raqamli parol kiriting",
  
    "bz1": "Yordam",
    "bz2": "Ko‘p so‘raladigan savollar",
    "bz3": "Savdo qoidalari",
    "bz4": "Pulni qanday yechish",
    "bz5": "Qanday qilib to‘ldirish",
  
    "bz6": "1. ebay Review RoBoT nima?",
    "bz7": "ebay Review RoBoT — bu marketing kompaniyasi bo‘lib, do‘konlarga buyurtmalarni oshirish va ko‘rishlar sonini ko‘paytirishga yordam beradi. Biz savdogarlar va foydalanuvchilar o‘rtasida uch tomonlama foyda modelini yaratamiz.",
    "bz8": "2. ebay Review RoBoT qanday ishlaydi?",
    "bz9": "Foydalanuvchi buyurtmani bosadi, tizim avtomatik buyurtma yaratadi. USDT orqali to‘lov qilinadi va komissiya olinadi.",
    "bz10": "3. Nega narxlar farq qiladi?",
    "bz11": "Narx farqi tarmoq, tezlik, hudud va boshqa omillarga bog‘liq.",
    "bz12": "4. Foyda haqida",
    "bz13": "Qimmat buyurtmalar — yuqori foyda beradi.",
    "bz14": "Kuniga 60 ta buyurtma, har biri uchun 0.6% komissiya.",
    "bz15": "60 ta buyurtmadan keyin yechish mumkin.",
    "bz16": "Har bir hisob faqat bitta USDT manzilga ulanadi.",
    "bz17": "24 soat ichida pul yechish amalga oshiriladi.",
    "bz18": "To‘ldirishdan oldin manzilni ulang (TRC20).",
    "bz19": "Hisoblar o‘rtasida pul o‘tkazish taqiqlanadi.",
  
    "ty1": "Tasdiqlash",
    "ty2": "Bekor qilish",
    "ty3": "Yuborish",
    "ty4": "TRC20 manzil",
    "ty5": "ERC20 manzil",
  
    "s1": "Umumiy daromad",
    "s2": "Xizmat",
    "s3": "Biz haqimizda",
    "s4": "Yordam",
    "s5": "Hamkorlar",
    "s6": "Mening xizmatlarim",
  
    "d1": "Tugallanmagan",
    "d2": "Tugallangan",
    "d3": "Ma’lumot yo‘q",
    "d4": "Buyurtma raqami",
    "d5": "Savdo vaqti",
    "d6": "Miqdor",
    "d7": "Joriy vazifalar",
    "d8": "Kutilayotgan foyda",
    "d9": "Qolgan",
    "d10": "Baholash",
  
    "j1": "Balans",
    "j2": "Savdo haqida",
    "j3": "Foydalanuvchi buyurtmani bajarib komissiya oladi.",
    "j4": "Boshlash",
    "j5": "Bugungi daromad",
    "j6": "Bajarilgan",
    "j7": "Jami vazifalar",
  
    "td1": "Balans",
    "td2": "Komissiya",
    "td3": "Qabul qilish",
    "td4": "Jami odam",
    "td5": "Foydalanuvchilar",
    "td6": "Hissa",
    "td7": "Soni",
    "td8": "Holat",
  
    "g1": "Pul yechish",
    "g2": "To‘ldirish",
    "g3": "Do‘stlarni taklif qilish",
    "g4": "Taklif qilish",
    "g5": "Do‘stlaringiz foydasidan komissiya oling",
    "g6": "Shaxsiy ma’lumot",
    "g7": "Moliyaviy tarix",
    "g8": "To‘ldirish tarixi",
    "g9": "Yechish tarixi",
    "g10": "Til",
    "g11": "Chiqish",
    "g12": "Chiqishni tasdiqlaysizmi",
  
    "yh1": "Foydalanuvchi ma’lumoti",
    "yh2": "O‘zgartirish",
    "yh3": "Sozlamalar",
    "yh4": "Telefon",
    "yh6": "Eski parol",
    "yh7": "Yangi parol",
  
    "mx1": "Komissiya",
    "mx2": "Daromad",
    "mx3": "Rad etildi",
    "mx4": "Vaqt",
    "mx5": "To‘ldirish muvaffaqiyatli",
    "mx6": "Rad etilgan",
    "mx7": "Kutilmoqda",
    "mx8": "Manzil",
    "mx9": "Balans",
    "mx10": "Haqiqiy summa",
    "mx11": "Summani kiriting",
  
    "cz2": "Nusxa olish",
    "cz3": "Valyuta tanlash",
    "cz4": "To‘lash",
    "cz5": "Faqat TRC20-USDT",
    "cz6": "Faqat ERC20",
  
    "qy1": "Kod",
  
    "yq1": "Taklif",
    "yq2": "Taklif kodi",
    "yq3": "Do‘stlarni taklif qiling va foyda oling",
    "yq4": "Taklif qilish",
  
    "zf1": "To‘lov usuli",
    "zf2": "Tanlang",
    "zf3": "Valyuta",
    "zf4": "Tarmoq",
    "zf5": "Savdoga o‘tish",
    "zf6": "Nusxa olindi",
    "zf7": "Valyuta",
    "zf8": "Iltimos foydalaning",
    "zf9": "Manzilga yuboring",
    "zf10": "Valyuta turi",
    "zf11": "Nusxa",
    "zf12": "Manzilni tekshiring",
    "zf13": "Yetib kelish vaqti",
    "zf14": "1~5 daqiqa",
    "zf15": "Minimal summa",
  
    "a1": "Marketing markazi",
    "a2": "Savdoni oshirish tizimi",
    "a3": "Foydalanuvchi buyurtma bajarib komissiya oladi",
    "a4": "Tizim doimiy rivojlanmoqda",
    // Mijozlarni qo'llab-quvvatlash
    "kf1": "Onlayn mijozlarni qo'llab-quvvatlash",
    "kf2": "Qo'lda mijozlarni qo'llab-quvvatlash orqali yechish",
    "kf3": "Yechish uchun qo'lda mijozlarni qo'llab-quvvatlash bilan bog'lanish uchun bu yerni bosing",
    "kf4": "Qo'lda mijozlarni qo'llab-quvvatlash orqali to'ldirish",
    "kf5": "To'ldirish uchun qo'lda mijozlarni qo'llab-quvvatlash bilan bog'lanish uchun bu yerni bosing",
    // To'lov variantlari oynasi
    "zf16": "Bank kartasi orqali operatsiyalar uchun mijozlarni qo'llab-quvvatlash xizmatiga murojaat qiling",
    "zf17": "Qo'llab-quvvatlash xizmatiga murojaat qiling"
  }